<div class="wrapper">
  <div class="cuerpo">

    <h1 class="tp-navandu line-navandu">REENVIAR DOCUMENTO</h1>

    @if (loading) {
    <app-spinner></app-spinner>
    } @else {
    <form name="entrar" [formGroup]="documentForm" class="formulario" autocomplete="off">
      @if (showSignatureChanels || documentForm.controls['signatureType'].value == 2 || template.templateType.name ===
      'File' || doneImageConvert==='loading') {
      <div class="documento">
        @if (documento.documentType === 'biometric') {
        <div class="flex-row">
          <mat-form-field>
            <mat-label>Dispositivo</mat-label>
            <mat-select formControlName="device">
              @for (device of devices; track device) {
              <mat-option [value]="device.deviceName">
                {{device.deviceDescription}}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        }
        @if (doneImageConvert==='loading') {
        <app-spinner></app-spinner>
        }
        @if (doneImageConvert === 'done') {
        <div>
          <div class="select-state">
            <button mat-icon-button class="refrescar" (click)="changePage('previus')">
              <div class="tooltip3">
                <mat-icon>chevron_left</mat-icon>
                <span class="tooltiptext3">Anterior</span>
              </div>
            </button>
            <p>Página: {{pageImagePdf +1}} de {{lengthPageImagePdf}}</p>
            <button mat-icon-button class="refrescar" (click)="changePage('next')">
              <div class="tooltip3">
                <mat-icon>chevron_right</mat-icon>
                <span class="tooltiptext3">Siguiente</span>
              </div>
            </button>
          </div>
          <div class="example-boundary" [style.backgroundImage]="'url('+ imagepdf +')'">
            @if (documento.template.templateType.name === 'File') {
            <div class="example-box" cdkDragBoundary=".example-boundary" cdkDrag (cdkDragEnded)="dragEnd($event)">
              Ubicación de firma
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
      <div class="enviar">
        <input type="submit" class="boton" value="Reenviar" (click)="onSubmit()" [disabled]="buttonDisable">
      </div>
      <a routerLink="/processes/{{idProcess}}" class="volver"><span>Volver</span> </a>
    </form>
    }

  </div>
</div>